import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatLegacyRadioButton as MatRadioButton } from '@angular/material/legacy-radio';
import HeightAndWidthAware from 'src/app/model/helper-interfaces/height-and-width-aware';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'height-and-width-selector',
  templateUrl: './height-and-width-selector.component.html',
  styleUrls: ['./height-and-width-selector.component.scss'],
})
export class HeightAndWidthSelectorComponent
  extends SubscriptionBasedComponent
  implements AfterViewInit
{
  @Input()
  rows: HeightAndWidthAware[][];
  @Input()
  heightAndWidthAware: HeightAndWidthAware;
  @Input()
  index: number;
  @Input()
  unselect: EventEmitter<any>;

  @Output()
  answer = new EventEmitter<HeightAndWidthAware>();

  @ViewChildren(MatRadioButton)
  radioButtons: QueryList<MatRadioButton>;

  anyChosen: boolean = false;

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngAfterViewInit(): void {
    if (this.radioButtons != null && this.radioButtons.length > 0) {
      for (const radioButton of this.radioButtons) {
        if (radioButton.checked) {
          this.anyChosen = true;
          break;
        }
      }
      if (this.unselect != null) {
        this.addSubscription(this.unselect, () => {
          this.radioButtons.forEach((r) => (r.checked = false));
          this.anyChosen = false;
        });
      }
    }
    this.cd.detectChanges();
  }

  setHeightAndWidth(entry: HeightAndWidthAware) {
    this.anyChosen = true;
    this.answer.emit(entry);
  }
}
